import { LANGUAGES, type Language } from '@fleetspoke/ui/tokens';
import TranslateIcon from '@mui/icons-material/Translate';
import { Button, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setLanguage } from '../i18n';

const LANGUAGE_NAMES: Record<Language, string> = { en: 'English', ms: 'Bahasa Melayu', zh: '中文' };

/** Language switcher: an icon in the app bar, or a labelled button (`labelled`) where there is room, e.g. sign-in. */
export function LanguageMenu({ labelled = false }: { labelled?: boolean }) {
  const { t, i18n } = useTranslation();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const current = (LANGUAGES as readonly string[]).includes(i18n.language)
    ? LANGUAGE_NAMES[i18n.language as Language]
    : LANGUAGE_NAMES.en;
  return (
    <>
      {labelled ? (
        <Button
          color="inherit"
          startIcon={<TranslateIcon />}
          onClick={(e) => setAnchor(e.currentTarget)}
          aria-label={t('common.language')}
          aria-haspopup="menu"
          sx={{ color: 'text.secondary' }}
        >
          {current}
        </Button>
      ) : (
        <Tooltip title={t('common.language')}>
          <IconButton
            onClick={(e) => setAnchor(e.currentTarget)}
            aria-label={t('common.language')}
            aria-haspopup="menu"
          >
            <TranslateIcon />
          </IconButton>
        </Tooltip>
      )}
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang}
            selected={LANGUAGE_NAMES[lang] === current}
            onClick={() => {
              setLanguage(lang);
              setAnchor(null);
            }}
          >
            {LANGUAGE_NAMES[lang]}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
